import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { validationSchema } from '../../../../utils/validationUtils';
import sty from './VerificationForm.module.css';
import PropTypes from 'prop-types';

const VerificationForm = ({ email, onSubmit, onResend }) => {
    // prop
    VerificationForm.propTypes = {
        email: PropTypes.string.isRequired,
        onSubmit: PropTypes.func.isRequired,
        onResend: PropTypes.func.isRequired,
    };
    
    // フォームのstateを更新
    const { register, handleSubmit, formState: { errors } } = useForm({
        mode: 'onBlur', // フォーカスが外れたときにバリデーションを実行
    });

    const [message, setMessage] = useState(null);

    const handleFormSubmit = (data) => {
        onSubmit(data, setMessage);
    };

    const handleResend = () => {
        onResend(email, setMessage);
    };

    return (
        <>
            <div className="page-tit">
                <div className="page-tit-outer">
                    <p className="page-tit-txt">認証コード入力</p>
                    <div className="page-tit-border"></div>
                </div>
            </div>
            <div className="inner-container">
                {message}
                <div className={sty['authentication__code']}>
                    <div className={sty['authentication__code-txt']}>
                        <label htmlFor="code"><p>メールアドレスに届いたコードを入力してください</p></label>
                        <input 
                            {...register('code', validationSchema.code)} 
                            type="number" 
                            id="code" 
                            className={sty['authentication__code-input']} 
                            autoComplete="one-time-code" 
                            pattern="[0-9]*" 
                            onWheel={(e) => e.target.blur()} 
                        />
                        {errors.code && <p className="form__validation-msg form__authentication-validation-msg">{errors.code.message}</p>}
                    </div>
                </div>
                <div className="primary-btns">
                    <button 
                        type="submit" 
                        className="primary-btn btn-large"
                        onClick={handleSubmit(handleFormSubmit)}
                    >
                        認証
                    </button>
                    <div 
                        className={sty['authentication__code-resend-link']} 
                        onClick={handleResend}
                    >
                        認証コードの再送信
                    </div>
                </div>
            </div>
        </>
    );
};

export default VerificationForm;